import { SITE_DEFAULT_OG_IMAGE } from '../data/projects';

/** MP4 in public/hero.mp4 or override with REACT_APP_HERO_VIDEO_URL. */
export const HERO_VIDEO_SRC =
  (typeof process !== 'undefined' && process.env.REACT_APP_HERO_VIDEO_URL) || '/hero.mp4';

export const HERO_VIDEO_POSTER = SITE_DEFAULT_OG_IMAGE;
